module.exports = __webpack_public_path__ + "assets/img/func4.ecebc821.png";